import { render, staticRenderFns } from "./lessonList.vue?vue&type=template&id=5dff4fa7"
import script from "./lessonList.vue?vue&type=script&lang=js"
export * from "./lessonList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports